import React from 'react';
import { Row, Col, Button, FormGroup } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import TextBox from 'components/Inputs/TextBox';
import DateRangePicker from 'components/Inputs/DateRangePicker';
import CheckBox from 'components/Inputs/CheckBox';
import dayjs from 'dayjs';
import { t } from 'i18next';
import * as EmployeeAction from 'store/actions/employee';
import * as PaymentTypeAction from 'store/actions/payment_type';

function FilterBox({ onSearch }) {
  const dispatch = useDispatch();
  const customStyles = {
    control: (base) => ({
      ...base,
      height: 35,
      minHeight: 35,
    }),
  };

  const branches = useSelector((state) => state.information.branches);
  const marketing_persons = useSelector((state) => state.information.marketing_persons);
  const payment_types = useSelector((state) => state.other_maintenance.payment_types);

  React.useEffect(() => {
    dispatch(EmployeeAction.getMarketingPerson());
    dispatch(PaymentTypeAction.getAll({}));
  }, [dispatch]);

  let branchOptions = [];
  if (branches?.map) {
    branchOptions = branches.map((e) => ({
      label: e.label,
      value: e._id,
    }));
  }

  let marketingPersonOptions = [];
  if (marketing_persons?.map) {
    marketingPersonOptions = marketing_persons.map((e) => ({
      label: e.label,
      value: e._id,
    }));
  }

  let paymentTypeOptions = [];
  if (payment_types?.map) {
    paymentTypeOptions = payment_types.map((e) => ({
      label: e.name,
      value: e._id,
    }));
  }

  const [searchType, setSearchType] = React.useState('invoice_number');
  const [search, setSearch] = React.useState('');
  const [destination, setDestination] = React.useState(null);
  const [marketingPerson, setMarketingPerson] = React.useState(null);
  const [paymentType, setPaymentType] = React.useState(null);
  const [dateSearch, setDateSearch] = React.useState(null);
  const [hasOutstandingBalance, setHasOutstandingBalance] = React.useState(false);

  return (
    <>
      <Row>
        <Col md='3' sm='6'>
          {searchType === 'destination' && (
            <Select
              styles={customStyles}
              options={branchOptions}
              onChange={(value) => setDestination(value)}
              value={destination}
              placeholder="Select Destination"
              isClearable
            />
          )}
          {searchType === 'marketing_person' && (
            <Select
              styles={customStyles}
              options={marketingPersonOptions}
              onChange={(value) => setMarketingPerson(value)}
              value={marketingPerson}
              placeholder="Select Sales Person"
              isClearable
            />
          )}
          {searchType === 'payment_type' && (
            <Select
              styles={customStyles}
              options={paymentTypeOptions}
              onChange={(value) => setPaymentType(value)}
              value={paymentType}
              placeholder="Select Payment Type"
              isClearable
            />
          )}
          {['invoice_number', 'id_no', 'license_no', 'waybill_number', 'quotation_no', 'customer_code', 'sender_name', 'receiver_name', 'phonenumber'].includes(searchType) && (
            <TextBox
              onChange={(e) => setSearch(e.target.value)}
              style={{ height: 34 }}
              value={search}
              placeholder={`Search by ${searchType.replace('_', ' ')}`}
            />
          )}
        </Col>
        <Col md='2' sm='6'>
          <Select
            styles={customStyles}
            defaultValue={{
              value: 'invoice_number',
              label: 'Invoice Number',
            }}
            onChange={(val) => {
              setSearch('');
              setDestination(null);
              setMarketingPerson(null);
              setPaymentType(null);
              setSearchType(val.value);
            }}
            options={[
              { value: 'invoice_number', label: 'Invoice Number' },
              { value: 'id_no', label: 'ID No' },
              { value: 'license_no', label: 'License No' },
              { value: 'waybill_number', label: 'Waybill No' },
              { value: 'quotation_no', label: 'Quotation No' },
              { value: 'customer_code', label: 'Customer Code' },
              { value: 'sender_name', label: 'Customer Name' },
              { value: 'receiver_name', label: 'Receiver Name' },
              { value: 'phonenumber', label: 'Phone Number' },
              { value: 'destination', label: 'Destination' },
              { value: 'marketing_person', label: 'Sales Person' },
              { value: 'payment_type', label: 'Payment Type' },
            ]}
          />
        </Col>

        <Col md='3' sm='6' style={{ height: 35 }}>
          <DateRangePicker
            onDateChange={(dates) => {
              setDateSearch({
                startDate: dates[0],
                endDate: dates[1],
              });
            }}
          />
        </Col>

        {/* <Col md='2' sm='6'>
          <FormGroup check style={{ marginTop: '8px' }}>
            <CheckBox
              checked={hasOutstandingBalance}
              onChange={(e) => setHasOutstandingBalance(e.target.checked)}
              label="Outstanding Only"
            />
          </FormGroup>
        </Col> */}

        <Col md='1' sm='6'>
          <Button
            size='sm'
            color='success'
            style={{ height: 35 }}
            onClick={() => {
              const searchData = {};
              
              if (search) searchData[searchType] = search.trim();
              if (destination) searchData.destination = destination.value;
              if (marketingPerson) searchData.marketing_person = marketingPerson.value;
              if (paymentType) searchData.payment_type = paymentType.value;
              if (hasOutstandingBalance) searchData.has_outstanding_balance = true;

              if (dateSearch?.startDate) {
                searchData.startDate = dayjs(dateSearch.startDate).format('YYYY-MM-DD');
                searchData.endDate = dateSearch.endDate 
                  ? dayjs(dateSearch.endDate).format('YYYY-MM-DD')
                  : dayjs(new Date()).format('YYYY-MM-DD');
              }

              onSearch(searchData);
            }}
          >
            <i className='fa fa-search' />
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default FilterBox;
